{
  "es": {
    "baseBtn": {
      "labels": {
        "loading": "Please wait..."
      },
      "confirm": {
        "question": "¿Seguro?",
        "yes": "Sí",
        "no": "No"
      }
    }
  }
}
